// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"394":"fba67cbe","412":"5e13aaac","496":"5e13aaac","558":"3bbcef9c","564":"3bbcef9c"}[chunkId] + ".chunk.css";
};